import { Table } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomFilterDropdownIcon from '../../../shared/components/filterDropdownComponent/CustomFilterDropdownIcon';
import { IP_DROPDOWN_SEARCH_INPUT_TYPES } from '../../../shared/constants/crmConstants';
import { getColumnSearchDropdownAbha } from '../abdmConstants';
import { RootState } from '../../../store';
import { fetchLinkedRecords } from '../../../store/actions/linkContextAction';
import { LinkContextModel } from '../../../store/models/linkContextModel';
import { checkEmptyObj } from '../../crm/inPatient/service/crmUtils';
import LinkRecordsModal from '../LinkDocsWithAbha/LinkRecordsModal';
import { resetFilter } from '../../../store/actions/abdmHiuAction';
import { ABDMHiuState } from '../../../store/models/abdmHIUModel';
import { getDateWithTime } from '../../../utils/dateTimeUtils';
const List = (): ReactElement => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any[]>([]);
  const [finalData, setFinalData] = useState<any[]>([]);
  const [tblLoading, setTblLoading] = useState(false);
  const [isRowClicked, setIsRowClicked] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const {reloadLinkedRecordsList, linkedRecordFilters} = useSelector((state: RootState): LinkContextModel => state.linkContext);
  const {searchClicked} = useSelector((state: RootState): ABDMHiuState => state.abdmHiu);
  const rowClick = (record: any): any => {
    setIsRowClicked(true);
    setSelectedRecord(record);
  };

  useEffect((): any => {
      dispatch(resetFilter({}));
  }, []);

  useEffect((): any => {
    setTblLoading(true);
    dispatch(fetchLinkedRecords(setConsentList));
  }, [reloadLinkedRecordsList]);

  useEffect((): void => {
    dispatch(fetchLinkedRecords(setConsentList));
  }, [searchClicked]);

  const setConsentList = (list: any[] = []): any => {
    setData(list);
    setTblLoading(false);
  };

  const RECORD_LIST_COLS = [
    {
      title: 'Patient Name',
      dataIndex: 'patientName',
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="patientName" />,
      ...getColumnSearchDropdownAbha({
        filterKey: 'patientName',
        searchFilterKey : 'PatientName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Patient Name',
      }),

    },
    {
      title: 'ABHA Address/No.',
      dataIndex: 'patientAbha',
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="patientAbha" />,
      ...getColumnSearchDropdownAbha({
        filterKey: 'patientAbha',
        searchFilterKey : 'PatientAbha',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search ABHA Address',
      }),
    },
    {
      title: 'Patient ID/Reg No.',
      dataIndex: 'patientReferenceNo',
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="patientReferenceNo" />,
      ...getColumnSearchDropdownAbha({
        filterKey: 'patientReferenceNo',
        searchFilterKey : 'PatientReferenceNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Reference Number',
      }),
    },
    {
      title: 'Care Context Description',
      dataIndex: 'careContextDesc',
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="careContextDesc" />,
      ...getColumnSearchDropdownAbha({
        filterKey: 'careContextDesc',
        searchFilterKey : 'CareContextDesc',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search description',
      }),
    },
    {
      title: 'Care Context Created On',
      dataIndex: 'createdOn',
      render: (createdOn: any): any => getDateWithTime(createdOn),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="createdOn" />,
      ...getColumnSearchDropdownAbha({
        filterKey: 'createdOn',
        searchFilterKey : 'CreatedOn',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE,
        placeholder: 'Search',
      }),
    },
    {
      title: 'Care Context Updated On',
      dataIndex: 'modifiedOn',
      render: (modifiedOn: any): any => getDateWithTime(modifiedOn),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="modifiedOn" />,
      ...getColumnSearchDropdownAbha({
        filterKey: 'modifiedOn',
        searchFilterKey : 'ModifiedOn',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE,
        placeholder: 'Search',
       }),
    },
    {
      title: 'Add Documents',
      dataIndex: '',
      render: ( _: any, record: any ): any =>
        <div className="add-documents-plus">
          <a onClick={(): any => rowClick(record)} className="plus-btn">+</a>
        </div>,
    },
  ];
  // ! Applying filters

 useEffect((): any => {
    if (!checkEmptyObj(linkedRecordFilters)) {
      const tempData = data?.filter((ele: any): boolean => {
        if (
          String(ele['patientAbha']).toLowerCase().includes((linkedRecordFilters.searchFilter || '')?.toLowerCase())
          || String(ele['patientReferenceNo']).toLowerCase().includes((linkedRecordFilters.searchFilter || '')?.toLowerCase())
        ) {
          return true;
        } else {
          return false;
        }
      });
      tempData?.sort((a: any, b: any): any => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());

      setFinalData(tempData);
    } else {
      data?.sort((a: any, b: any): any => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());
      setFinalData(data);
    }
  }, [linkedRecordFilters, data]);

  return (
    <div>
      <Table
        loading={tblLoading}
        columns={RECORD_LIST_COLS}
        dataSource={finalData}
        className="tableClass"
        rowKey="id"
        pagination={{ pageSize: 10, position: ['bottomCenter'] }}
      />
      {isRowClicked && <LinkRecordsModal
      setVisible={setIsRowClicked}
      visible={isRowClicked}
      isEdit={true}
      selectedRecord={selectedRecord} />}
    </div>
  );
};

export default List;
